import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { Checkbox } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';

import validate from '../validate';
import { RenderError } from 'components/shared/RenderError';

import scrollIntoView from 'scroll-into-view';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getCurrentLocale } from 'helpers/i18n';
import { localizePrivacyStatementLink } from 'helpers/Localization';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  button: {
    color: 'white',
    height: '40px',
  },
};

let WizardFormFirstPage = (props) => {
  const { handleSubmit, previousPage, privacyStatementLink } = props;
  const language = getCurrentLocale();

  return (
    <div id="top" style={{ marginTop: '50px' }}>
      <div>
        <div style={{ width: '100%', marginBottom: '20px' }}>
          <span
            style={{
              fontSize: '30px',
              marginBottom: '20px',
              fontFamily: 'Circular-Bold',
            }}
          >
            {getTranslatedString('tenantPortal.application.consent.agree')}{' '}
            <i style={{ width: '1em', height: '1em' }} className="em em-smiley" />
          </span>
        </div>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.agreeWarning')}
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement')}
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.communication')}
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.reports')}
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.credit')}
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.blankWarning')}s
        </p>
        <p style={{ textAlign: 'justify', marginBottom: '15px' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.signature')}
        </p>
      </div>
      <div style={{ marginBottom: '20px' }}>
        <p style={{ textAlign: 'justify' }}>
          {getTranslatedString('tenantPortal.application.consent.statement.securityData')}
          <a
            href={localizePrivacyStatementLink(privacyStatementLink, language)}
            target="_blank"
            rel="noreferrer noopener"
          >
            {getTranslatedString('tenantPortal.application.consent.statement.privacyPolicy')}
          </a>
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ textAlign: 'center', marginBottom: '90px' }}>
          <Field
            name="agreeToTerms"
            component={Checkbox}
            label={getTranslatedString('tenantPortal.application.consent.statement.button')}
            style={{ margin: 'auto', width: '237px' }}
            className="agreeToTerms"
          />
          <Field name="agreeToTerms" component={RenderError} />
        </div>
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label={getTranslatedString('tenantPortal.application.consent.statement.buttonBack')}
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label={getTranslatedString('tenantPortal.application.consent.statement.buttonNext')}
              type="submit"
              className="next"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

WizardFormFirstPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
    });
  },
})(WizardFormFirstPage);

WizardFormFirstPage = connect((state) => ({
  initialValues: state.tenantApplication.tenantApplication,
}))(WizardFormFirstPage);

export default WizardFormFirstPage;
